import { InjectionToken, ɵɵdefineInjectable, Injectable, ɵɵinject, PLATFORM_ID, Optional, Inject } from '@angular/core';
import { TranslateDefaultParser, TranslateService } from '@ngx-translate/core';
import { isPlatformBrowser } from '@angular/common';

const NgxTranslateDebugConfigDefault = {
    localStorageKey: 'ngx-translate-debug',
};
const NGX_TRANSLATE_DEBUG_CONFIG = new InjectionToken('ngx-translate-debug.config');

class NgxTranslateDebugParser extends TranslateDefaultParser {
    constructor() {
        super(...arguments);
        this.debug = false;
    }
    getValue(target, key) {
        return this.debug ? key : super.getValue(target, key);
    }
}
NgxTranslateDebugParser.ɵprov = ɵɵdefineInjectable({ factory: function NgxTranslateDebugParser_Factory() { return new NgxTranslateDebugParser(); }, token: NgxTranslateDebugParser, providedIn: "root" });
NgxTranslateDebugParser.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];

class NgxTranslateDebugService {
    constructor(ngxTranslateDebugConfig, platformId, translateService) {
        this.ngxTranslateDebugConfig = ngxTranslateDebugConfig;
        this.platformId = platformId;
        this.translateService = translateService;
        this.config = Object.assign(NgxTranslateDebugConfigDefault, this.ngxTranslateDebugConfig || {});
        this.isBrowser = isPlatformBrowser(this.platformId);
        if (this.isBrowser && +localStorage.getItem(this.config.localStorageKey)) {
            this.enableDebug();
        }
    }
    get parser() {
        return this.translateService.parser;
    }
    get isDebugMode() {
        return this.parser.debug;
    }
    set isDebugMode(value) {
        this.parser.debug = value;
        if (this.isBrowser) {
            localStorage.setItem(this.config.localStorageKey, value ? '1' : '0');
        }
    }
    enableDebug() {
        if (this.isDebugMode) {
            console.log('ngx-translate debug mode already enabled');
            return;
        }
        this.isDebugMode = true;
        this.triggerTranslatesUpdate();
    }
    disableDebug() {
        if (!this.isDebugMode) {
            console.log('ngx-translate debug mode already disabled');
            return;
        }
        this.isDebugMode = false;
        this.triggerTranslatesUpdate();
    }
    toggleDebug() {
        this.isDebugMode ? this.disableDebug() : this.enableDebug();
        this.triggerTranslatesUpdate();
    }
    triggerTranslatesUpdate() {
        this.translateService.onLangChange.emit({
            lang: this.translateService.currentLang,
            translations: this.translateService.translations,
        });
    }
}
NgxTranslateDebugService.ɵprov = ɵɵdefineInjectable({ factory: function NgxTranslateDebugService_Factory() { return new NgxTranslateDebugService(ɵɵinject(NGX_TRANSLATE_DEBUG_CONFIG, 8), ɵɵinject(PLATFORM_ID), ɵɵinject(TranslateService)); }, token: NgxTranslateDebugService, providedIn: "root" });
NgxTranslateDebugService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
NgxTranslateDebugService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [NGX_TRANSLATE_DEBUG_CONFIG,] }] },
    { type: Object, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: TranslateService }
];

/*
 * Public API Surface of ngx-translate-debug
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NGX_TRANSLATE_DEBUG_CONFIG, NgxTranslateDebugConfigDefault, NgxTranslateDebugParser, NgxTranslateDebugService };
